<template>
  <span>
    <slot name="activator" :open="open">
      <oie-base-action
        v-tooltip.top="tStatic('requestQuoteButtonTooltip')"
        class="request-quote-slide-in__activator"
        theme="outlined-white"
        size="large"
        @click.stop="open">
        {{ tStatic('requestQuoteButtonLabel') }}
      </oie-base-action>
    </slot>
    <oie-portal-wrapper :name="name">
      <template #title>
        <h2>{{ tStatic('requestQuoteSlideInHeader') }}</h2>
      </template>
      <validation-observer v-if="!hasSentRequest" ref="observer" tag="div">
        <oie-form-wrapper class="input-column__container" @submit="requestQuote">
          <p>{{ tStatic('requestQuoteSlideInText').replace('{0}', itemId) }}</p>

          <validation-provider v-slot="{errors}" slim rules="required">
            <oie-base-input v-model="request.formData.firstName" :label-text="`${tStatic('firstNameLabel')}*`" :error-messages="errors"></oie-base-input>
          </validation-provider>

          <validation-provider v-slot="{errors}" slim rules="required">
            <oie-base-input v-model="request.formData.lastName" :label-text="`${tStatic('lastNameLabel')}*`" :error-messages="errors"></oie-base-input>
          </validation-provider>

          <validation-provider v-slot="{errors}" slim rules="required|email">
            <oie-base-input v-model="request.formData.email" :label-text="`${tStatic('email')}*`" :error-messages="errors"></oie-base-input>
          </validation-provider>

          <oie-base-input
            v-if="get(clientModel, 'user.isCompanyCustomer') || !clientModel.isAuthenticated"
            v-model="request.formData.company"
            :label-text="tStatic('companyNameLabel')"></oie-base-input>

          <validation-provider
            v-slot="{errors}"
            rules="required|numeric"
            slim>
            <oie-base-input
              v-model="phoneProxy"
              :label-text="`${tStatic('phoneLabel')}*`"
              :placeholder="tStatic('phonePlaceholderLabel')"
              :max-length="27"
              :error-messages="errors"
              :prefix-value="selectedActiveCountry ? selectedActiveCountry.callingCode : null"></oie-base-input>
          </validation-provider>

          <validation-provider
            v-slot="{errors}"
            rules="required"
            slim>
            <oie-base-input
              id="errand"
              v-model="request.formData.subject"
              :textarea="true"
              :label-text="`${tStatic('requestQuoteLabel')}*`"
              :placeholder="tStatic('requestQuotePlaceholder')"
              :error-messages="errors"
              :max-length="500"></oie-base-input>
          </validation-provider>

          <validation-provider
            rules="checked"
            slim
            mode="passive">
            <template v-slot="{ errors }">
              <oie-base-checkbox v-model="acceptGdpr" :errors="errors" :text="tStatic('requestQuoteGdprConsent')"></oie-base-checkbox>
            </template>
          </validation-provider>

          <oie-base-action type="submit" size="large">
            {{ tStatic('sendQuoteRequestButtonLabel') }}
          </oie-base-action>

          <div class="caption" v-html="tStatic('requestQuoteAlternativeContactText')"></div>
        </oie-form-wrapper>
      </validation-observer>

      <div v-else class="request-quote-slide-in__success-message">
        <p>{{ tStatic('requestQuoteConfirmText') }}</p>
        <oie-base-action size="large" @click="setActiveSlideIn(null)">{{ tStatic('genericClose') }}</oie-base-action>
      </div>
    </oie-portal-wrapper>
  </span>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import utils from '@/core/utils'
import countryHandling from '@/mixins/country-handling'
import httpService from '@/core/http-service'

export default {
  mixins: [countryHandling],
  props: {
    itemId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      request: {
        formType: 'quote',
        formData: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          company: '',
          subject: '',
          article: null
        }
      },
      acceptGdpr: false,
      hasSentRequest: false
    }
  },
  computed: {
    phoneProxy: {
      get() {
        return this.selectedActiveCountry ? utils.extractPhoneNumberFromFormating(this.request.formData.phone, this.selectedActiveCountry.callingCode) : this.request.formData.phone
      },
      set(value) {
        this.selectedActiveCountry ? this.request.formData.phone = utils.savePhoneNumberWithFormating(value, this.selectedActiveCountry.callingCode) : this.request.formData.phone = value
      }
    }
  },
  beforeMount() {
    this.name = this.$attrs.id || _.uniqueId('request-quote-slide-in')
    this.prepopulateForm()
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    open() {
      this.setActiveSlideIn(this.name)
    },
    prepopulateForm() {
      this.request.formData.article = this.itemId

      if(this.clientModel.isAuthenticated) {
        this.request.formData.firstName = this.clientModel.user.firstName
        this.request.formData.lastName = this.clientModel.user.lastName
        this.request.formData.email = this.clientModel.user.userName
        this.request.formData.company = this.clientModel.user.name

        this.setActiveCountry(this.clientModel.user.country.value)
        this.request.formData.phone = this.clientModel.user.userPhone
      } else {
        this.setActiveCountry(this.defaultCountry.value)
      }
    },
    async requestQuote() {
      const isValid = await this.$refs.observer.validate()
      if(!isValid) return
      await httpService.post('cart/offerarticle', this.request)
      this.hasSentRequest = true
    }
  }
}
</script>

<style lang="scss">
.request-quote-slide-in__activator {
  width: 100%;
}

.request-quote-slide-in__success-message {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: measure(half)
}
</style>
